import { useTranslation } from "react-i18next";
import CompetitorCard from "../../competitorAnalysisCard";

export const TitleCompetitorAnalysis = ({ competitorResults, analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {competitorResults && (
        <>
          {/* Title Uniqueness */}
          <div className="mt-5">
            <p className="text-sm mb-2 font-semibold">
              {t("H1-title-uniqueness", "H1 title uniqueness")}
            </p>

            <p
              className={`${
                analysis?.uniqueness == 100
                  ? "text-green-500"
                  : analysis?.uniqueness == 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              } text-sm mb-2 font-semibold`}
            >
              {analysis?.uniqueness == 100
                ? `${t(
                    "Your-H1-title-is-different-from-those-of-your-competitors",
                    "Your H1 title is different from those of your competitors"
                  )}.`
                : analysis?.uniqueness == 0
                ? `${t(
                    "Your-H1-title-is-already-used-by-a-competitor",
                    "Your H1 title is already used by a competitor"
                  )}.`
                : t("Please-add-title", "Please-add-title")}
            </p>
          </div>
          {competitorResults && competitorResults?.analysis?.length > 0 && (
            <>
              <p className="text-white text-xl mt-6 mb-4 font-bold">
                {t("Competition", "Competition")}
              </p>
            </>
          )}
          {competitorResults?.analysis?.map((item, index) => {
            return (
              <CompetitorCard
              key={competitorResults.contents[index]?.url || index} 
                type={"title"}
                index={index}
                general={competitorResults.general}
                content={competitorResults.contents[index]}
                analysis={item}
                seoRequest={competitorResults.seo_request}
                url={competitorResults.contents[index].url}
              ></CompetitorCard>
            );
          })}
        </>
      )}
    </>
  );
};
